import { BaseIcon } from './BaseIcon';

const DevelopersIcon = (props) => {
  return (
    <BaseIcon {...props}>
      <path
        d="M8 8.23853L3 12.2385L8 16.2385M16 16.2385L21 12.2385L16 8.23853"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </BaseIcon>
  );
};

export default DevelopersIcon;
